export default __webpack_public_path__ + "static/media/play-button-content.f28987cb.svg";